import * as React from "react";

import { useTheme } from "@v2/hooks/useTheme";
import { Outlet } from "react-router-dom";

export function PublicThemeLayout() {
  const { effectiveMode, palette } = useTheme();

  // eslint-disable-next-line replo/no-use-effect -- Browser chrome uses document metadata outside the route subtree.
  React.useEffect(() => {
    const themeColorMeta = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    const previousThemeColor = themeColorMeta?.content;
    if (themeColorMeta) {
      themeColorMeta.content = palette.sheet;
    }
    return () => {
      if (themeColorMeta && previousThemeColor) {
        themeColorMeta.content = previousThemeColor;
      }
    };
  }, [palette.sheet]);

  return (
    <>
      <style>{`
        html, body { background-color: ${palette.sheet} !important; color-scheme: ${effectiveMode}; }
        [data-public-theme] [data-slot="input"] { border-width: 1px; }
        [data-public-theme][data-agent-theme="dark"] [data-slot="input"][aria-invalid="true"] {
          border-color: var(--color-rose-400);
          background-color: color-mix(in srgb, var(--color-rose) 3%, var(--color-sheet));
        }
      `}</style>
      <Outlet />
    </>
  );
}
